import PropTypes from 'prop-types'
import {
  DesktopTable,
  HeaderRow,
  ValueColumnHeading,
  PersonRows,
  BalanceGutter,
  NameLabel,
  ValueRow,
  Cell,
  MobileCard,
  MobileTitle,
  MobileSection,
  MobileSectionName,
  MobileDivider,
  MobileValueRow,
  MobileValue,
  MobileArrow,
} from './style'

function DesktopRow({ name, currentAge, planAge }) {
  return (
    <ValueRow>
      <NameLabel>{name}</NameLabel>
      <Cell>{currentAge}</Cell>
      <Cell planned>{planAge}</Cell>
      <BalanceGutter />
    </ValueRow>
  )
}

function MobilePersonSection({ name, currentAge, planAge }) {
  return (
    <MobileSection>
      {name && <MobileSectionName>{name}</MobileSectionName>}
      <MobileValueRow>
        <MobileValue>{currentAge}</MobileValue>
        <MobileArrow />
        <MobileValue planned noChange={planAge === currentAge}>
          {planAge}
        </MobileValue>
      </MobileValueRow>
    </MobileSection>
  )
}

const personRowPropTypes = {
  name: PropTypes.string,
  currentAge: PropTypes.number.isRequired,
  planAge: PropTypes.number.isRequired,
}

DesktopRow.propTypes = personRowPropTypes
MobilePersonSection.propTypes = personRowPropTypes

function RetirementAgeTable({
  isMobile,
  includeSpouse,
  isModified,
  participantName,
  currentAge,
  planAge,
  spouseName,
  spouseCurrentAge,
  spousePlanAge,
}) {
  const planLabel = isModified ? 'Your changes' : 'Recommended'

  // Show names only when they are needed to distinguish two rows.
  const participantLabel = includeSpouse ? participantName : null

  if (isMobile) {
    return (
      <MobileCard>
        <MobileTitle>{includeSpouse ? 'Retirement age' : 'Your retirement age'}</MobileTitle>
        <MobilePersonSection name={participantLabel} currentAge={currentAge} planAge={planAge} />

        {includeSpouse && (
          <>
            <MobileDivider />
            <MobilePersonSection
              name={spouseName}
              currentAge={spouseCurrentAge}
              planAge={spousePlanAge}
            />
          </>
        )}
      </MobileCard>
    )
  }

  return (
    <DesktopTable>
      <HeaderRow>
        <BalanceGutter />
        <ValueColumnHeading>CURRENT</ValueColumnHeading>
        <ValueColumnHeading planned>{planLabel}</ValueColumnHeading>
        <BalanceGutter />
      </HeaderRow>

      <PersonRows>
        <DesktopRow name={participantLabel} currentAge={currentAge} planAge={planAge} />

        {includeSpouse && (
          <DesktopRow name={spouseName} currentAge={spouseCurrentAge} planAge={spousePlanAge} />
        )}
      </PersonRows>
    </DesktopTable>
  )
}

RetirementAgeTable.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  includeSpouse: PropTypes.bool.isRequired,
  isModified: PropTypes.bool.isRequired,
  participantName: PropTypes.string,
  currentAge: PropTypes.number.isRequired,
  planAge: PropTypes.number.isRequired,
  spouseName: PropTypes.string,
  spouseCurrentAge: PropTypes.number,
  spousePlanAge: PropTypes.number,
}

export default RetirementAgeTable
